var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "queryParams",
          attrs: {
            model: _vm.queryParams,
            inline: "",
            "label-width": "80px",
            "label-position": "left",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "角色名" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入角色名称" },
                model: {
                  value: _vm.queryParams.roleName,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "roleName", $$v)
                  },
                  expression: "queryParams.roleName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { "label-width": "0px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-search", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.refresh()
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.reset()
                    },
                  },
                },
                [_vm._v("重置")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["role:save"],
                      expression: "['role:save']",
                    },
                  ],
                  attrs: { icon: "el-icon-plus", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addRole()
                    },
                  },
                },
                [_vm._v("添加")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["role:delete"],
                      expression: "['role:delete']",
                    },
                  ],
                  attrs: {
                    icon: "el-icon-delete",
                    type: "primary",
                    disabled: _vm.delBtnDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.removeBatch()
                    },
                  },
                },
                [_vm._v("删除\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("table-page", {
        ref: "tablePage",
        attrs: {
          url: _vm.tableUrl,
          columns: _vm.columns,
          "query-params": _vm.queryParams,
        },
        on: { "table-select-val": _vm.selectVal },
        scopedSlots: _vm._u([
          {
            key: "roleStatus",
            fn: function (ref) {
              var row = ref.row
              var index = ref.index
              return _vm._l(_vm.statusOptionList, function (item) {
                return row.roleStatus === item.dictValue
                  ? _c("el-tag", { attrs: { type: item.listClass } }, [
                      _vm._v(
                        "\n        " + _vm._s(item.dictLabel) + "\n      "
                      ),
                    ])
                  : _vm._e()
              })
            },
          },
          {
            key: "dataScope",
            fn: function (ref) {
              var row = ref.row
              var index = ref.index
              return _vm._l(_vm.dataScopeOptionList, function (item) {
                return row.dataScope === item.dictValue
                  ? _c("el-tag", { attrs: { type: item.listClass } }, [
                      _vm._v(
                        "\n        " + _vm._s(item.dictLabel) + "\n      "
                      ),
                    ])
                  : _vm._e()
              })
            },
          },
          {
            key: "action",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["role:update"],
                        expression: "['role:update']",
                      },
                    ],
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.update(row)
                      },
                    },
                  },
                  [_vm._v("修改")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["role:delete"],
                        expression: "['role:delete']",
                      },
                    ],
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.remove(row)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["role:auth:resource"],
                        expression: "['role:auth:resource']",
                      },
                    ],
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.authModule(row)
                      },
                    },
                  },
                  [_vm._v("授权")]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            label: _vm.dialogTitle,
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogShow = $event
            },
            close: function ($event) {
              return _vm.handleReset("form")
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "名称", prop: "roleName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入角色名称" },
                    model: {
                      value: _vm.form.roleName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "roleName", $$v)
                      },
                      expression: "form.roleName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "权限字符", prop: "roleKey" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入角色权限字符串" },
                    model: {
                      value: _vm.form.roleKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "roleKey", $$v)
                      },
                      expression: "form.roleKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "roleStatus" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.roleStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "roleStatus", $$v)
                        },
                        expression: "form.roleStatus",
                      },
                    },
                    [
                      _vm._l(_vm.statusOptionList, function (item) {
                        return [
                          _c("el-radio", { attrs: { label: item.dictValue } }, [
                            _vm._v(_vm._s(item.dictLabel)),
                          ]),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "数据范围", prop: "roleStatus" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请输入数据范围" },
                      model: {
                        value: _vm.form.dataScope,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "dataScope", $$v)
                        },
                        expression: "form.dataScope",
                      },
                    },
                    [
                      _vm._l(_vm.dataScopeOptionList, function (item) {
                        return [
                          _c("el-option", {
                            attrs: {
                              value: item.dictValue,
                              label: item.dictLabel,
                            },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.form.dataScope === "2"
                    ? _c("el-tree", {
                        ref: "deptTree",
                        attrs: {
                          data: _vm.deptTree,
                          "show-checkbox": "",
                          "default-expand-all": "",
                          "node-key": "id",
                          "default-checked-keys": _vm.dataScopeDeptIds,
                          props: { children: "children", label: "name" },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleReset("form")
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleSubmit("form")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.dialogModuleShow
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "授权模块",
                visible: _vm.dialogModuleShow,
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogModuleShow = $event
                },
                close: function ($event) {
                  _vm.dialogModuleShow = false
                },
              },
            },
            [
              _c("el-tree", {
                ref: "moduleTree",
                attrs: {
                  data: _vm.moduleData,
                  "node-key": "id",
                  "show-checkbox": "",
                  "default-checked-keys": _vm.defModuleIds,
                  props: {
                    children: "children",
                    label: "title",
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogModuleShow = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveAuthModule()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }